'use client'

import { useCallback, useEffect, useState } from 'react'

interface ImageItem {
  url: string
  thumb: string
  caption?: string
}

interface ImageManagerResponse {
  images: ImageItem[]
  total: number
}

export function useImageManager(
  sellerId: string | number,
  pageSize: number = 12
) {
  const [images, setImages] = useState<ImageItem[]>([])
  const [total, setTotal] = useState(0)

  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    if (!sellerId) {
      setImages([])
      setTotal(0)
      setLoading(false)
      return
    }

    setLoading(true)

    try {
      const res = await fetch(
        `/api/image-manager` +
          `?seller_id=${sellerId}` +
          `&page=${page}` +
          `&limit=${pageSize}`
      )

      if (!res.ok) {
        throw new Error('Failed to load images')
      }

      const data: ImageManagerResponse = await res.json()

      setImages(data.images || [])
      setTotal(data.total || 0)
    } catch (err) {
      console.error('ImageManager load error', err)
      setImages([])
      setTotal(0)
    } finally {
      setLoading(false)
    }
  }, [sellerId, page, pageSize])

  // 🔁 Cargar al montar y cuando cambie page / seller
  useEffect(() => {
    load()
  }, [load])

  return {
    images,
    total,
    page,
    setPage,
    loading,
    reload: load,
  }
}
